function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgClose(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 21,
    viewBox: "0 0 21 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M16.166 4.49219L4.16609 16.4921",
    stroke: "#205A46",
    style: {
      stroke: "#205A46",
      stroke: "color(display-p3 0.1255 0.3529 0.2745)",
      strokeOpacity: 1
    },
    strokeWidth: 1.5,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.166 16.4922L4.16609 4.49226",
    stroke: "#205A46",
    style: {
      stroke: "#205A46",
      stroke: "color(display-p3 0.1255 0.3529 0.2745)",
      strokeOpacity: 1
    },
    strokeWidth: 1.5,
    strokeLinecap: "round"
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClose);
export default __webpack_public_path__ + "static/media/close.a4d06fe3384795258d6a1ba467e2261b.svg";
export { ForwardRef as ReactComponent };